function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import Input from "./input";

var baseStyle = _extends({}, Input.baseStyle.field, {
  paddingY: "8px",
  minHeight: "80px",
  lineHeight: "short"
});

var variants = {
  outline: function outline(props) {
    return Input.variants.outline(props).field;
  },
  flushed: function flushed(props) {
    return Input.variants.flushed(props).field;
  },
  filled: function filled(props) {
    return Input.variants.filled(props).field;
  },
  unstyled: Input.variants.unstyled.field
};
var sizes = {
  sm: Input.sizes.sm.field,
  md: Input.sizes.md.field,
  lg: Input.sizes.lg.field
};
var defaultProps = {
  size: "md",
  variant: "outline"
};
export default {
  baseStyle: baseStyle,
  sizes: sizes,
  variants: variants,
  defaultProps: defaultProps
};